import api from '../../api';

import {  
    ACTION_FETCHING_MAYORS_IN_PROGRESS,
    ACTION_FETCHING_MAYORS_COMPLETED,
    ACTION_STORE_FETCHED_MAYORS,
    ACTION_FETCHING_MAYOR_IN_PROGRESS,
    ACTION_FETCHING_MAYOR_COMPLETED,
    ACTION_STORE_FETCHED_MAYOR,
    ACTION_REMOVE_MAYOR,
    ACTION_SET_MAYOR_FILTERS,
    ACTION_CLEAR_MAYOR_REDUCER,
    ACTION_SET_MAYOR_PAGE,
    ACTION_SET_MAYOR_TYPE,
    ACTION_STORE_ADDITIONAL_MAYORS,
    ACTION_CREATING_MAYOR_IN_PROGRESS,
    ACTION_CREATING_MAYOR_COMPLETED,
    ACTION_FETCHING_ALL_MAYORS_IN_PROGRESS,
    ACTION_STORE_FETCHED_ALL_MAYORS,
    ACTION_FETCHING_ALL_MAYORS_COMPLETED,
    ACTION_EDITING_MAYOR_IN_PROGRESS,
    ACTION_EDITING_MAYOR_COMPLETED,
    ACTION_FETCHING_MAYOR_OPTIONS_IN_PROGRESS,
    ACTION_STORE_MAYOR_OPTIONS,
    ACTION_FETCHING_MAYOR_OPTIONS_COMPLETED,
    ACTION_DELETING_MAYOR_IN_PROGRESS,
    ACTION_DELETING_MAYOR_COMPLETED,
    ACTION_FETCHING_ADDITIONAL_MAYORS_IN_PROGRESS,
    ACTION_FETCHING_ADDITIONAL_MAYORS_COMPLETED
} from './mayorActionsList';
import history from '../router/history';

//? Fetches all the mayors that match the user selection //
export const getMayors = (filters) => {
    return async (dispatch, getState) => {
        try {
            const type = getState().mayors.type;
            const page = 1;

            dispatch(ACTION_SET_MAYOR_PAGE(1));
            dispatch(ACTION_FETCHING_MAYORS_IN_PROGRESS());
            
            const response = await api.getMayors(filters, page, type);
            if(response && response.data){
                dispatch(ACTION_STORE_FETCHED_MAYORS(response.data.mayors, response.data.totalItems));
            }
            dispatch(ACTION_FETCHING_MAYORS_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_MAYORS_COMPLETED());
        }   
    }
}

export const getMoreMayors = (filters) => {
    return async (dispatch, getState) => {
        try {
            const type = getState().mayors.type;
            const page = getState().mayors.page;

            dispatch(ACTION_FETCHING_ADDITIONAL_MAYORS_IN_PROGRESS());
            const response = await api.getMayors(filters, page, type);
            if(response && response.data){
                dispatch(ACTION_STORE_ADDITIONAL_MAYORS(response.data.mayors));
            }
            dispatch(ACTION_FETCHING_ADDITIONAL_MAYORS_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_ADDITIONAL_MAYORS_COMPLETED());
        }   
    }
}

//? Fetches a single Mayor //
export const getMayor = (id) => {
    return async (dispatch) => {
        try {
            dispatch(ACTION_FETCHING_MAYOR_IN_PROGRESS());
            const response = await api.getMayor(id);
            if(response && response.data){
                dispatch(ACTION_STORE_FETCHED_MAYOR(response.data.mayor));
            }
            dispatch(ACTION_FETCHING_MAYOR_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_MAYOR_COMPLETED());
        }   
    }
}

//? Removes the single mayor in state //
export const removeMayor = () => {
    return (dispatch) => {
        dispatch(ACTION_REMOVE_MAYOR());
    }
}

export const setMayorFilters = (filters) => {
    return (dispatch) => {
        dispatch(ACTION_SET_MAYOR_FILTERS(filters));
    }
}

export const clearMayorState = () => {
    return (dispatch) => {
        dispatch(ACTION_CLEAR_MAYOR_REDUCER());
    }
}

export const setMayorPage = (page) => {
    return (dispatch) => {
        dispatch(ACTION_SET_MAYOR_PAGE(page));
    }
}

export const setMayorType = (type) => {
    return (dispatch, getState) => {
        const oldType = getState().mayors.type;
        if(oldType === type) type = '';
        dispatch(ACTION_SET_MAYOR_TYPE(type));
    }
}

export const createMayor = (mayor) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_CREATING_MAYOR_IN_PROGRESS());
            const response = await api.createMayor(mayor);
            if(response && response.data){
                history.push('/dashboard/mayors')
            }
            dispatch(ACTION_CREATING_MAYOR_COMPLETED());
        } catch (error) {
            dispatch(ACTION_CREATING_MAYOR_COMPLETED());
        }   
    }
}

export const getAllMayors = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_FETCHING_ALL_MAYORS_IN_PROGRESS());
            const response = await api.getAllMayors();
            if (response?.data?.mayors) {
                dispatch(ACTION_STORE_FETCHED_ALL_MAYORS(response.data.mayors))
            }
            dispatch(ACTION_FETCHING_ALL_MAYORS_COMPLETED());
        } catch (error) {
            dispatch(ACTION_FETCHING_ALL_MAYORS_COMPLETED());
        }
    }
}

export const editMayor = (mayor, id) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_EDITING_MAYOR_IN_PROGRESS());
            const response = await api.editMayor(mayor, id);
            if (response?.data?.mayor) {
                history.replace('/dashboard/mayors');
            }
            dispatch(ACTION_EDITING_MAYOR_COMPLETED());
        } catch (error) {
            dispatch(ACTION_EDITING_MAYOR_COMPLETED());
        }
    }
}
export const getMayorOptions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_FETCHING_MAYOR_OPTIONS_IN_PROGRESS());
            const response = await api.getMayorOptions();
            if (response?.data?.options) {
                dispatch(ACTION_STORE_MAYOR_OPTIONS(response.data.options))
            }
            dispatch(ACTION_FETCHING_MAYOR_OPTIONS_COMPLETED());
        } catch (error) {
            dispatch(ACTION_FETCHING_MAYOR_OPTIONS_COMPLETED());
        }
    }
}
export const deleteMayor = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_DELETING_MAYOR_IN_PROGRESS());
            await api.deleteMayor(id);
            dispatch(ACTION_DELETING_MAYOR_COMPLETED());
        } catch (error) {
            dispatch(ACTION_DELETING_MAYOR_COMPLETED());
        }
    }
}